module.exports = __webpack_public_path__ + "static/media/Burger.f07645ab.jpg";